import {browserStorageKey} from '@dms/config';

/**
 * The DMS UI language as an `accept-language` header, or no header before the app stored one.
 * Prompt Bridge forwards it to DMS, so record fact labels come back in the language of the UI.
 */
export function getUiLanguageHeader(): Record<string, string> {
  const language = localStorage.getItem(browserStorageKey.LAST_KNOWN_LANGUAGE);

  return language ? {'accept-language': language} : {};
}
